module.exports = __webpack_public_path__ + "static/rt-patterson.61add6dc.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/portfolio/rt-patterson.webp
// module id = 445
// module chunks = 23899280101116